/**
 *
 * MediaTypeOptionB
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { fallbackImage } from 'utils/stringUtils';
import AppsIcon from './images/apps.svg';
import ArticlesIcon from './images/articles.svg';
import BooksIcon from './images/books.svg';
import FAQIcon from './images/faqs.svg';
import NewsIcon from './images/news.svg';
import OrganizationsIcon from './images/organizations.svg';
import PodcastsIcon from './images/podcasts.svg';
import ProgramsIcon from './images/programs.svg';
import VideosIcon from './images/videos.svg';

const imagesMap = {
  Apps: AppsIcon,
  Articles: ArticlesIcon,
  Books: BooksIcon,
  FAQ: FAQIcon,
  News: NewsIcon,
  Organizations: OrganizationsIcon,
  Podcasts: PodcastsIcon,
  'Online Programs': ProgramsIcon,
  Videos: VideosIcon,
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ECECEC',
    padding: 7,
    margin: '5px 10px',
    color: '#4B4B4B',
    cursor: 'pointer',
  },
  selected: {
    borderColor: '#01619B',
    backgroundColor: '#01619B',
    color: '#FFFFFF',
  },
  image: {
    height: 22,
    width: 22,
    borderRadius: 11,
    marginRight: 7,
  },
});

const MediaTypeOptionB = ({ onSelect, selected, data, type }) => {
  const classes = useStyles();

  return (
    <div
      className={_classNames({
        [classes.container]: true,
        [classes.selected]: selected,
      })}
      onClick={() => onSelect(type, data)}
      role="button"
      tabIndex={0}
    >
      <img
        className={classes.image}
        src={imagesMap[data.value] || fallbackImage}
        alt={`${data.value} Media Type`}
      />
      <Typography variant="body2" align="center">
        {data.value}
      </Typography>
    </div>
  );
};

MediaTypeOptionB.propTypes = {
  onSelect: PropTypes.func,
  data: PropTypes.object,
  selected: PropTypes.bool,
  type: PropTypes.string,
};

export default MediaTypeOptionB;
